import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MessageComponent } from './message/message.component';
import { SearchFilterComponent } from '@routes/dialogs/search-filter/search-filter.component';
import { SharedModule } from '@shared/shared.module';
import { ComponentsModule } from '@components/components.module';
import { CustomerSearchComponent } from './customer-search/customer-search.component';
import { CustomerDetailComponent } from './customer-detail/customer-detail.component';
import { SearchFilterNameComponent } from './search-filter-name/search-filter-name.component';
import { AttachmentViewComponent } from './attachment-view/attachment-view.component';
import { ProductsHistoryComponent } from './products-history/products-history.component';
import { RepairStatusComponent } from './repair-status/repair-status.component';
import { ReportComponent } from './report/report.component';
import {
  ConcealedDamageDetailActionsComponent
} from './concealed-damage-detail-actions/concealed-damage-detail-actions.component';
import { ConcealedDamagePhotoComponent } from '@routes/dialogs/concealed-damage-photo/concealed-damage-photo.component';
import {
  ConcealedDamageDetailQuestionComponent
} from '@routes/dialogs/concealed-damage-detail-question/concealed-damage-detail-question.component';
import { CompanySelectorComponent } from './company-selector/company-selector.component';
import { RejectServiceRequest } from '@routes/dialogs/reject-service-request/reject-service-request.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { FileUploadModule } from 'ng2-file-upload';
import { DeleteDataComponent } from './delete-data/delete-data.component';
import { TicketCreatedDetailComponent } from './ticket-created-detail/ticket-created-detail.component';
import { MatTooltipModule } from '@angular/material/tooltip';


@NgModule({
  declarations: [
    MessageComponent,
    SearchFilterComponent,
    CustomerSearchComponent,
    CustomerDetailComponent,
    SearchFilterNameComponent,
    AttachmentViewComponent,
    ProductsHistoryComponent,
    RepairStatusComponent,
    ReportComponent,
    ConcealedDamageDetailActionsComponent,
    ConcealedDamagePhotoComponent,
    ConcealedDamageDetailQuestionComponent,
    CompanySelectorComponent,
    RejectServiceRequest,
    FileUploadComponent,
    DeleteDataComponent,
    TicketCreatedDetailComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    ComponentsModule,
    FileUploadModule,
    MatTooltipModule,
  ]
})
export class DialogsModule {
}
